export default __webpack_public_path__ + "img/map.09021a7d.svg";